import { render, staticRenderFns } from "./shipData.vue?vue&type=template&id=aa59b374&scoped=true&"
import script from "./shipData.vue?vue&type=script&lang=js&"
export * from "./shipData.vue?vue&type=script&lang=js&"
import style0 from "./shipData.vue?vue&type=style&index=0&id=aa59b374&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa59b374",
  null
  
)

export default component.exports